import { NavLink, Outlet } from 'react-router'
import { History, Image, LayoutDashboard, LogOut, Settings, UserCog, Users } from 'lucide-react'
import { useAuth } from '../lib/auth'
import { TYPE_ORDER, TYPES } from '../lib/types'
import PublishButton from './PublishButton'

const link = ({ isActive }: { isActive: boolean }) =>
  `flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm transition ${
    isActive ? 'bg-accent/10 font-semibold text-accent' : 'text-muted hover:bg-surface-2 hover:text-fg'
  }`

export default function Layout() {
  const { user, signOut } = useAuth()
  return (
    <div className="min-h-screen md:grid md:grid-cols-[15rem_1fr]">
      <aside className="border-b border-line bg-surface md:sticky md:top-0 md:h-screen md:overflow-y-auto md:border-b-0 md:border-e">
        <div className="flex items-center justify-between px-4 py-4">
          <div>
            <p className="text-sm font-bold">MLOps MENA</p>
            <p className="text-xs text-faint">Content admin</p>
          </div>
        </div>
        <nav className="space-y-0.5 px-2 pb-4">
          <NavLink to="/" end className={link}><LayoutDashboard className="h-4 w-4" />Dashboard</NavLink>
          <p className="px-3 pb-1 pt-4 text-[11px] font-semibold uppercase tracking-wide text-faint">Content</p>
          {TYPE_ORDER.map((t) => (
            <NavLink key={t} to={`/content/${t}`} className={link}>{TYPES[t].label}</NavLink>
          ))}
          <NavLink to="/content/settings" className={link}><Settings className="h-4 w-4" />Site copy</NavLink>
          <NavLink to="/media" className={link}><Image className="h-4 w-4" />Media</NavLink>
          <p className="px-3 pb-1 pt-4 text-[11px] font-semibold uppercase tracking-wide text-faint">Site</p>
          <NavLink to="/publish" className={link}><History className="h-4 w-4" />Publish history</NavLink>
          {user.role === 'admin' && <NavLink to="/users" className={link}><Users className="h-4 w-4" />Users</NavLink>}
          <NavLink to="/account" className={link}><UserCog className="h-4 w-4" />My account</NavLink>
        </nav>
      </aside>

      <div className="min-w-0">
        <header className="sticky top-0 z-10 flex items-center justify-between gap-3 border-b border-line bg-bg/90 px-5 py-3 backdrop-blur">
          <p className="truncate text-sm text-muted">
            {user.name} <span className="chip ms-1">{user.role}</span>
          </p>
          <div className="flex items-center gap-2">
            <PublishButton />
            <button className="btn" onClick={() => void signOut()}>
              <LogOut className="h-3.5 w-3.5" /> Sign out
            </button>
          </div>
        </header>
        <main className="mx-auto max-w-5xl px-5 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
